<template>
  <div>
    <div class="row">
      <div class="col">
        <div class="border bg-light p-3">
          Last Updated: <strong class="text-success">{{ ago }}</strong> ({{
            moment(lastFetched).format("h:mm:ss on ddd MMM Y")
          }})
        </div>
      </div>
    </div>
    <data-table
      :items="items"
      v-on:updateData="getQuotations"
      :sortOptions="sortOptions"
      :filterOptions="filterOptions"
      :sort="sort"
      :isLoad="isLoad"
      :page="page"
      :rowsPerPage="rowsPerPage"
      :fromRow="fromRow"
      :toRow="toRow"
      :totalRows="totalRows"
      :lastPage="lastPage"
    >
      <template v-slot:headings>
        <div class="col-md-4">Customer</div>
        <div class="col-md-2">Total</div>
        <div class="col-md-2">Branch</div>
        <div class="col-md-2">Date</div>
      </template>

      <template v-slot:rows="slotProps">
        <div class="col-md-4 font-size-13 my-auto">
          <span class="text-primary font-weight-bold">{{
            slotProps.item.quotation_number
          }}</span>
          -
          {{ slotProps.item.customer.name }}
          {{ slotProps.item.customer.name }}
        </div>
        <div class="col-md-2 font-size-13 my-auto">
          {{  parseFloat(slotProps.item.total).toFixed(2) | currency }}
        </div>
        <div class="col-md-2 font-size-13 my-auto">
          <span v-if="slotProps.item.branch">{{
            slotProps.item.branch.code
          }}</span>
        </div>
        <div class="col-md-2 font-size-13 my-auto">
          {{
            moment(new Date(slotProps.item.created_at)).format(
              "DD MMM YY, HH:mm"
            )
          }}
        </div>

        <div class="col-md-2 text-right my-auto">
         
          <span
            class="text-info table-action-icon"
            @click="
              selectedQuotation = slotProps.item;
              quotationDetailToggle = true;
            "
          >
            <i class="lni lni-search-alt"></i>
          </span>
        </div>
      </template>
    </data-table>

    <b-modal
      :hide-footer="true"
      title="Quotation Details"
      size="lg"
      v-model="quotationDetailToggle"
      v-if="selectedQuotation != null"
      @hidden="update"
    >
      <template #modal-header>
        <div class="row">
          <div class="col-auto">
            <span class="bg-primary text-white px-3 py-1">{{
              selectedQuotation.quotation_number
            }}</span>
          </div>
          <div class="col">
            <h4 class="m-0">{{ selectedQuotation.customer.name }}</h4>
            <small class="text-muted">{{
              selectedQuotation.customer.trading_as
            }}</small>
          </div>
        </div>
        <button type="button" class="close" @click="quotationDetailToggle = false">
          X
        </button>
      </template>

      <div class="row">
        <div class="col-md-6">
          <table class="table table-sm mt-2">
            <table-row label="Branch" :no-border="true"
              >{{ selectedQuotation.branch.name }}
            </table-row>

            <table-row
              label="Code"
              :no-border="true"
              :copyText="selectedQuotation.customer.rapid_code"
              ><strong>{{ selectedQuotation.customer.rapid_code }} </strong>
            </table-row>
        
            <table-row label="Date" :no-border="true"
              >{{
                moment(new Date(selectedQuotation.created_at)).format(
                  "DD MMM YYYY, HH:mm:ss"
                )
              }}
            </table-row>
          </table>
        </div>
        <div class="col-md-6">
          <table class="table table-sm border mt-2">
            <table-row
              label="Cust. Ref"
              :no-border="true"
              :copyText="selectedQuotation.customer_reference"
              >{{ selectedQuotation.customer_reference }}
            </table-row>
           
            <table-row label="Notes" :no-border="true">
              <span class="text-danger font-weight-bold">
                {{ selectedQuotation.note }}
              </span>
            </table-row>
          </table>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="table-responsive">
            <table class="table table-bordered table-striped">
              <thead>
                <tr class="bg-dark text-white font-size-11 l-s-1">
                  <th>CODE</th>
                  <th>NAME</th>
                  <th class="text-center">QTY</th>
                  <th class="text-center">PRICE</th>
                  <th class="text-center">MASS</th>
                  <th class="text-right">TOTAL</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="product in selectedQuotation.quotation_products"
                  :key="product.id"
                >
                  <td>                   
                      {{ product.product.code }}
                  </td>

                  <td>
                    {{ product.product.name }}
                  </td>

                  <td class="text-center">
                    {{ product.quantity }}
                  </td>

                  <td class="text-center">
                    {{ product.price }}
                  </td>

                  <td class="text-center">
                    <span v-if="product.product.price_extended_by_mass == 1">
                      {{ parseFloat(product.product.average_mass)  * parseFloat(product.quantity)}}
                    </span>
                  </td>

                  <td class="text-right">
                    <strong>{{ parseFloat(product.sub_total).toFixed(2) | currency }}</strong>
                  </td>

                
                </tr>
                <tr>
                  <td colspan="6" class="text-right">
                    <h5>Sub Total: <strong>{{ parseFloat(selectedQuotation.sub_total).toFixed(2) | currency }}</strong></h5>
                  </td>
                </tr>
                <tr>
                  <td colspan="6" class="text-right">
                    <h5>VAT: <strong>{{ parseFloat(selectedQuotation.vat).toFixed(2) | currency }}</strong></h5>
                  </td>
                </tr>
                <tr>
                  <td colspan="6" class="text-right">

                    <div v-if="loading">
                      <b-spinner
                        variant="primary"
                        style="width: 3rem; height: 3rem"
                        label="Large Spinner"
                      ></b-spinner>
                    </div>
                    
                    <button class="btn btn-primary float-left" @click="pdf()">PDF</button>
                    <h5>Total: <strong>{{ parseFloat(selectedQuotation.total).toFixed(2) | currency }}</strong></h5>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

    
    </b-modal>
  </div>
</template>

<script>
import quotationRepo from "@/api/repos/quotationRepo";
import dataTable from "@/components/common/DataTable";
import tableRow from "@/components/common/TableRow";
import moment from "moment";


export default {
  components: {
    dataTable: dataTable,
    tableRow: tableRow,
  },

  

  data() {
    return {
      timer: null,
      timer2: null,
      lastFetched: null,
      ago: null,
      selectedQuotation: null,
      quotationDetailToggle: false,
      isLoad: false,
      sort: { column: "created_at", label: "Date Created Desc", quotation: "Desc" },
      sortOptions: [
        { column: "created_at", label: "Date Created Asc", quotation: "asc" },
        { column: "created_at", label: "Date Created Desc", quotation: "desc" },
      ],
      filterOptions: [],
      page: 1,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 12,
      fromRow: 0,
      toRow: 0,
      totalRows: 0,
      lastPage: 0,
      items: [],
      submitStatus: null,
      errors: null,
      loading: false,
     
    };
  },
  mounted() {
    this.getData(false);
    this.timer = setInterval(this.getData, 120000, true);
    this.timer2 = setInterval(this.updateLastFetched, 5000, true);
  },
  methods: {
    updateLastFetched() {
      this.ago = moment(this.lastFetched).fromNow();
    },
    async update() {
      this.getData(true);
    },
    getData(updating) {
      this.getQuotations(
        {
          sort: this.sort,
          filters: null,
          page: this.page,
          rowsPerPage: localStorage.getItem("rowsPerPage")
            ? localStorage.getItem("rowsPerPage")
            : 12,
          search: "",
        },
        updating
      );
    },
    async getQuotations(e, updating = false) {
      if (!updating) {
        this.isLoad = true;
      }
      try {
        let { data } = await quotationRepo.repQuotations(
          e.page,
          e.rowsPerPage,
          e.sort.column,
          e.sort.quotation,
          e.search,
          e.filters != null ? e.filters : null
        );

       

        this.items = data.quotations.data;
        this.totalRows = data.quotations.total;
        this.page = data.quotations.current_page;
        this.fromRow = data.quotations.from;
        this.toRow = data.quotations.to;
        this.lastPage = data.quotations.last_page;

        this.filterOptions = [];

        

        this.filterOptions.push({
          column: "group-heading",
          label: "branches",
        });

        data.reps.forEach((b) => {
          this.filterOptions.push({
            column: "branch_id",
            value: b.branch_id,
            label: b.branch.name,
          });
        });

        this.lastFetched = Date.now();
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoad = false;
      }
    },
    async pdf(){
      this.loading = true;
      try {
        let response = await quotationRepo.pdf(this.selectedQuotation.id);
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", `quotation-${this.selectedQuotation.quotation_number}.pdf`);
        document.body.appendChild(fileLink);

        fileLink.click();
        } catch (error) {
          console.log(error);
          this.loading = false;
        }finally{
          this.loading = false;
        }
    }
   
  },
  beforeRouteLeave(to, from, next) {
    if (this.timer) clearInterval(this.timer);
    if (this.timer2) clearInterval(this.timer2);
    next();
  },

  destroyed() {
    if (this.timer) clearInterval(this.timer);
    if (this.timer2) clearInterval(this.timer2);
  },

  watch: {
    $route: {
      immediate: true,
      handler: function (newVal) {
        this.quotationDetailToggle = newVal.meta && newVal.meta.quotationDetailToggle;
      },
    },
  },
};
</script>
